import React,{useState} from "react";
import { FollowedCompany } from "../../../components/admin/Dashboard/following/FollowedCompany";
import { FollowedCompanyCard } from "../../../components/admin/Dashboard/following/FollowedCompanyCard";
import FollowNewCom from "../../../components/admin/Dashboard/following/FollowNewCompanies";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as CompaniesFollow } from "../../../assets/icons/CompanyYouFollow.svg";
import { ReactComponent as Magnifier } from "../../../assets/icons/Magnifier.svg";
import { Card } from "../../../components/common";


const Following = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [companyData, setCompanyData] = useState(userInfo?.companyFollow || []);

  const onSearchCompany = (event) => {
    let newArray = [];
    userInfo?.companyFollow.filter(function (el) {
      if (el?.companyID?.registered_company_name.toLowerCase().includes(event.target.value.toLowerCase()))
        newArray.push(el);
    });
    setCompanyData(newArray);

  }
  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          <Card classes="w-full  md:col-start-1 md:col-end-10 flex flex-col sm:flex-row justify-between">
            <FollowedCompany />
            <div className="pb-3 flex items-center relative">
              <Magnifier className="absolute mb-3 mx-3 sm:left-0 sm:right-0 " />
              <input
                type="text"
                placeholder="Search company"
                className="border-input border w-full bg-inputInterface text-f16 p-2 px-11 mb-3 shadow-search rounded"
                onChange={(event) => onSearchCompany(event)}
              />
            </div>
          </Card>
          {companyData.map((company) => (
            <FollowedCompanyCard company={company.companyID} follow={company} />
          ))}
          {companyData?.length === 0 && (
            <div className="flex flex-col items-center gap-5 justify-center sm:w-1/3 mx-auto p-5 ">
              <CompaniesFollow />
              <span className="text-secondary text-f14">
                Follow companies and stay updated about any changes
              </span>
              <Link
                to="/search"
                target="_blank"
                className="border-link text-link font-semibold border py-2 px-5 rounded text-f14"
              >
                Start Following
              </Link>
            </div>
          )}
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col">
          <FollowNewCom type="follow"/>
        </div>
      </div>
    </>
  );
};

export default Following;
